/* Library */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';

import { connect } from 'react-redux';

import { asyncConnect } from 'redux-connect';
import ApplyCSS from '../../../../components/ApplyCSS';
/* import GRHeader from './../../../../components/GRHeader'; */

import Celebraciones from './components/Celebraciones';
import TodoTipoDeEventos from './components/TodoTipoDeEventos';
import AppEvents from '../../../App/AppEvents';
import * as labelsActions from '../../../../components/labels/actions';
import commonUtil from '../../../../utils/commonUtil';
import * as EventCategoryActions from '../../../../components/eventcategory/actions';
import * as createEventObject from '../../../createEvent/actions';
import serverClientUtil from '../../../../utils/serverClientUtil';
import { createTag } from '../../../../utils/googleTagManagerUtils';

const constChannel = commonUtil.getClientConstForChannel();
const { isCreateEventDataLoaded, defineCreateEventData } = createEventObject;
const { isLablesLoaded, loadLables } = labelsActions;
const { isEventCategoryLoaded, loadEventCategoryEvent } = EventCategoryActions;
const pageName = 'SelectMesaType';
const channel = commonUtil.getChannel();
const applicationRoutes = commonUtil.getApplicationRoutes();

@asyncConnect([
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isLablesLoaded(getState())) {
        return dispatch(loadLables());
      }
      return undefined;
    },
  },
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isEventCategoryLoaded(getState())) {
        return dispatch(loadEventCategoryEvent());
      }
      return undefined;
    },
  },
  {
    promise: ({ store: { dispatch, getState } }) => {
      if (!isCreateEventDataLoaded(getState(), pageName)) {
        return dispatch(defineCreateEventData(pageName, ''));
      }
      return undefined;
    },
  },
])

@connect(
  store => ({
    user: store.user.data,
    lables: store.labels.data,
    error: store.labels.error,
    loading: store.labels.loading,
    extraData: store.labels.extraData,
    eventCategoryType: store.eventcategory.data,
  }),
  { ...labelsActions, EventCategoryActions, ...createEventObject },
)

class SelectMesaType extends Component {
  constructor(props) {
    super(props);
    this.benefits = this.benefits.bind(this);
  }

  handleLinkClick = (selectedEventCategory) => {
    createTag({
      event: 'mesa_regalos',
      phase: 'Crear mesa de regalos',
      step: 'Selecciona el tipo de mesa de regalos',
      selection: selectedEventCategory,
      seccion: 'Mesa de Regalos',
    });
  };

  handleClickMesaType = (e, messType) => {
    const { defineCreateEventData: defineCreateEventDataProp } = this.props;
    defineCreateEventDataProp(pageName, messType);
  };

  benefits = (type) => {
    const eventType = type;
    browserHistory.push({ pathname: applicationRoutes.benefits, state: eventType });
  };

  static propTypes = {
    lables: PropTypes.object,
  };

  componentWillUnmount() {
    if (channel === constChannel.WAP) {
      AppEvents.unsubscribe(this.wapBackButtonEvent);
    }
  }

  // TODO: Test with mock
  handleBackClick = () => {
    const { user = {} } = this.props;
    const result = user?.result || {};
    const { myEventDetail = [], emailId = '' } = result;

    const eventDetails = myEventDetail;

    if (user && emailId && myEventDetail.length > 1) {
      browserHistory.push(applicationRoutes.multipleEvents);
    }

    if (emailId && myEventDetail.length === 1) {
      browserHistory.push(commonUtil.routeTo(applicationRoutes.giftList, { eventID: eventDetails[0].eventId }));
    }

    browserHistory.push('/');
  };

  componentDidMount() {
    if (channel === constChannel.WAP) {
      this.wapBackButtonEvent = AppEvents.subscribe(AppEvents.EVENT_REGISTER.WAP_BACK_BUTTON_CLICKED);
      AppEvents.publish(this.wapBackButtonEvent, [this.handleBackClick]);
    }
  }

  handleLoginWithAuth0 = () => {
    const url = serverClientUtil.getLPFullURL();
    const redirectUrl = 'https:' + url + '/login';
    const redirectBackUrl = `${window.location.origin}/crearevento/seleccioneeltipodemesa`;
    window.location.replace(
      `${redirectUrl}?redirectAfterLoginHref=${redirectBackUrl}&originalRedirectHref=${window.location.origin}`,
    );
  };

  // ? Document this
  componentDidUpdate() {
    // redirect to the auth0 login page from eCommerce website
    if (!this.props.user.result.firstName) {
      this.handleLoginWithAuth0();
    }
  }

  renderwebdata() {
    const { lables, eventCategoryType = {} } = this.props;

    return (
      <React.Fragment>
        <div className="container createEventAnimationRight">
          <div className="row innerMain" style={{ background: '#f7f3f0' }}>
            <div className="col-sm-12 col-md-12">
              <div className="innerWrap">
                <p className="welcomeMessage">
                  {commonUtil.getLabel(lables.categoryLanding, 'categoryLanding.welcome.message')}
                </p>
                <h2 className="selectEvent-h2--custom">
                  {commonUtil.getLabel(lables.categoryLanding, 'categoryLanding.select.message')}
                </h2>
                <div className="col-sm-6 col-md-6">
                  <Celebraciones
                    onLinkClick={this.handleLinkClick}
                    eventCategoryData={eventCategoryType}
                    labels={lables}
                    handleClickMesaType={this.handleClickMesaType}
                  />
                  <p
                    dangerouslySetInnerHTML={{
                      __html: commonUtil.getLabel(lables.categoryLanding, 'categoryLanding.benefit.celebration'),
                    }}
                  />
                </div>
                <div className="col-sm-6 col-md-6">
                  <TodoTipoDeEventos
                    onLinkClick={this.handleLinkClick}
                    eventCategoryData={eventCategoryType}
                    labels={lables}
                    handleClickMesaType={this.handleClickMesaType}
                  />
                  <p
                    dangerouslySetInnerHTML={{
                      __html: commonUtil.getLabel(lables.categoryLanding, 'categoryLanding.benefit.open'),
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }

  renderwapdata() {
    const { lables, eventCategoryType } = this.props;
    return (
      <div className="borderTop">
        <div className="row">
          <div className="col-xs-12">
            <div className="innerWrap" style={{ margin: '30px 0' }}>
              <p className="welcomeMessage" style={{ fontSize: '19px', color: '#737873', textAlign: 'left' }}>
                Bienvenido a la Mesa de regalos
              </p>
              <h2 style={{ fontSize: '23px', color: '#3b3b3e', textAlign: 'left' }}>
                Selecciona el tipo de mesa de regalos
              </h2>
              <div className="col-xs-6">
                <Celebraciones
                  onLinkClick={this.handleLinkClick}
                  eventCategoryData={eventCategoryType}
                  labels={lables}
                  benefits={this.benefits}
                  handleClickMesaType={this.handleClickMesaType}
                />
              </div>
              <div className="col-xs-6">
                <TodoTipoDeEventos
                  onLinkClick={this.handleLinkClick}
                  eventCategoryData={eventCategoryType}
                  labels={lables}
                  benefits={this.benefits}
                  handleClickMesaType={this.handleClickMesaType}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <React.Fragment>
        <ApplyCSS pageName="selectMesaType" />
        {channel === 'wap' ? this.renderwapdata() : this.renderwebdata()}
      </React.Fragment>
    );
  }
}

export default SelectMesaType;
